<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <b-card  class="formGroup">
            <Form ref="AddForm" :loading="loading" :forms="FilterForm" />
             <template slot="footer">
                <b-button variant="primary" @click="saveForm">{{$t('general.save')}}</b-button>
            </template>
        </b-card>
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import i18n from '@/plugins/i18n';
    import Form from '@/components/Form'
    import Forms from './forms'
    import {prepareRequestData, setFormData} from '@/assets/js/custom.js'
    import jwt_decode from "jwt-decode";

    let breadCrumb = [
        { label: 'AD / LDAP', url: "" },
        { label: 'LDAP Filtreleri', url: "/User/LDAP/Filters" },
        { label: 'LDAP Filtresi Ekle', url: "/User/LDAP/Filters/Add" },
    ]
    export default {
        name: 'LDAPFilterAdd',
        data: function(){
            return{
                breadCrumb,
                FilterForm: Forms.ADFilter,

            }
        },
        components:{
            BreadCrumb, Form
        },
        computed:{
            loading(){
                return this.$store.getters.getUserLoading || this.$store.getters.getLDAPLoading
            },
            getJWT(){
                return jwt_decode(localStorage.getItem('access_token'))
            }
        },
        methods:{

            saveForm: function(){
                this.$refs.AddForm.$refs.Form.validate().then( async success =>{
                    if(success){
                        let data;
                        data = prepareRequestData(this.FilterForm, this.$refs.AddForm.formData)
                            await this.$store.dispatch('adfilter_add', data)
                            if(this.$store.getters.getLDAPStatus.status == "Success"){
                                this.$router.push('/User/LDAP/Filters')
                            }
                       
                    }
                })  
            }
        }
    }
</script>
<style lang="css" scoped > 
    @import "./styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Users/AddLDAPFilter.vue